<template>
    <calendar/>
</template>
<script>
import calendar from '@/components/fullCalendario'

export default {
    name: 'VistaRutas',
    components:{
        calendar
    },
    mounted(){
        this.$store.state.reloadMenu = true;
    }
}
</script>